module.exports = __webpack_public_path__ + "static/media/user.471a1ad3.png";